<template>
  <main>
    <div class="container-fluid devoir">
      <div class="row">
        <div class="col-md-12">
          <TopTemplate>
            <template #right-element>
              <router-link :to="{name: 'examScheduleAdd'}" class="btn button btn-primary" :disabled="!loading">
                <i class="icon-Add" />
                {{ $t("button.scheduleExam") }}
              </router-link>
            </template>
            <template #left-element>
              <h3>{{ $t("title.examScheduleTitle") }}</h3>
            </template>
          </TopTemplate>
        </div>
      </div>
      <div class="ajout-container row bloc container-select container-filter">
        <div class="col-sm-8 container-select container-filter top-filter">
          <div class="info-filter">
            <p>{{ $t("register.filter.titleExam") }}</p>
            <span>{{ $t("register.filter.description") }}</span>
          </div>
        </div>
        <!-- <div v-if="isSelected" class="col-sm-4 container-select container-filter top-filter">
          <div class="reset_student reset_note" @click="resetFilter()">
            <i class="icon-reset" />
            {{ $t("notes.reset") }}
          </div>
        </div> -->
        <div class="supparation"></div>

        <div class="row container-select container-filter top-register">
          <div class="col-md-6 col-12 select-wrapper bloc-title">
            <div>
              <v-select
                v-model="selectedLevel"
                :searchable="true"
                :options="levels"
                label="name"
                class="form-control"
                :reduce="(option) => option"
                @update:modelValue="ChangeLevel($event)"
                placeholder="Niveau"
              >
                <template #no-options="{search, searching, loading}">
                  <div v-if="!loading" class="card mt-2 text-center d-block pt-2 pb-2">
                    {{ $t("common.emptysearshType") }}
                  </div>
                  <div v-else class="card mt-2 text-center d-block pt-2 pb-24">
                    <div class="spinner-border text-info" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </div>
                </template>
              </v-select>
            </div>
          </div>
          <div class="col-md-6 col-12 select-wrapper">
            <div>
              <v-select
                v-model="selectedClass"
                :options="classes"
                label="name"
                placeholder="Classe"
                :searchable="true"
                :disabled="!selectedLevel || selectedLevel.length === 0"
                :reduce="(option) => option"
                class="form-control"
                @update:modelValue="ChangeClass($event)"
              >
                <template #no-options="{search, searching, loading}">
                  <div v-if="!loading" class="card mt-2 text-center d-block pt-2 pb-2">
                    {{ $t("common.emptysearchClasse") }}
                  </div>
                  <div v-else class="card mt-2 text-center d-block pt-2 pb-24">
                    <div class="spinner-border text-info" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </div>
                </template>
              </v-select>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 register-clalender">
          <FullCalendar :options="options" ref="calendarexam"> </FullCalendar>
        </div>
        <div class="col-lg-8 collapse-register">
          <div v-if="loading" class="mt-4 text-center d-block pt-4 pb-4">
            <div class="spinner-border text-info" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          <div v-if="exams.length === 0 && selectedClass" class="top-msg">
            <p>{{ $t("register.msgEmpty") }}</p>
          </div>
          <div v-if="!selectedClass && exams.length === 0 && !loading" class="top-msg">
            <p>{{ $t("register.msgEmpty") }}</p>
          </div>
          <div v-if="exams.length > 0" class="top-date">
            <p>{{ formattedDate }}</p>
          </div>
          <div v-for="(item, index) in exams" :key="item.id" class="general-info">
            <div class="accordion" @click="toggleCollapse(index)">
              <div class="row">
                <div class="col-md-10 left calender-item">
                  <span class="time"> {{ formatHours(item.start_time) }} - {{ formatHours(item.end_time) }}</span>
                  <span class="level-name">{{ item.classe.name }}</span>
                  <span class="course-name">
                    <span v-if="item.field"> {{ item.field.name_fr }} | </span> {{ item.course.name }} | {{ item.exam_type.name }}</span
                  >
                </div>

                <div class="col-md-2 right edit-calendar">
                  <router-link
                    :to="{
                      name: 'examScheduleEdit',
                      params: {id: item.id},
                    }"
                    class
                  >
                    <i class="icon-edit-02" v-if="item.can_edit">
                      <span class="tooltiptext">{{ $t("button.tooltip.update") }}</span>
                    </i>
                  </router-link>
                  <div class="right__icons-wrapper">
                    <i :class="{'icon-Minus color-green': item.expanded, 'icon-Add color-green': !item.expanded}"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="panel collapse-contenu" v-show="item.expanded">
              <p>{{ item.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import ExamScheduleService from "../../services/examSchedule.Service";
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import RegisterClass from "../../services/registerClass.service";
import moment from "moment";
import FullCalendar from "@fullcalendar/vue3";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import frLocale from "@fullcalendar/core/locales/fr";
import vSelect from "vue-select";
export default {
  components: {
    FullCalendar,
    TopTemplate,
    "v-select": vSelect,
  },
  data() {
    return {
      isSelected: false,
      selectedLevel: null,
      selectedClass: null,
      exams: [],
      calender: [],
      levels: [],
      loading: true,
      params: {
        date: moment().format("YYYY-MM-DD"),
        class: null,
      },
      options: {
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        locale: frLocale,
        selectable: true,
        select: this.handleSelect,
        headerToolbar: {
          left: "prev",
          center: "title",
          right: "next",
        },
        eventDidMount: this.eventDidMount,
        dateClick: this.handleDateClick,
        eventClassNames: this.setEventClass,
        datesSet: this.handleDatesSet,
        editable: true,
        events: [],
      },
    };
  },
  computed: {
    formattedDate() {
      return this.params.date ? moment(this.params.date).format("DD MMMM YYYY") : null;
    },
  },
  async mounted() {
    await this.FilterRegister();
  },

  methods: {
    handleDatesSet() {
      //  this.params.date

      this.$nextTick(() => {
        const dayElements = document.querySelectorAll(".fc-daygrid-day");

        // Loop through each .fc-daygrid-day element
        dayElements.forEach((dayElement) => {
          // Check if .fc-daygrid-block-event exists within the current .fc-daygrid-day
          const eventElement = dayElement.querySelector(".fc-daygrid-block-event");

          // If it exists, find and style the .fc-daygrid-day-number within the current .fc-daygrid-day
          if (eventElement) {
            const dayNumberElement = dayElement.querySelector(".fc-daygrid-day-number");
            dayNumberElement.style.background = "#F1FAFA";
            dayNumberElement.style.cursor = "pointer";
          }
        });
      });
    },

    toggleCollapse(index) {
      this.exams[index].expanded = !this.exams[index].expanded;
    },
    formatHours(date) {
      const heure = date.split(":")[0];
      const minute = date.split(":")[1];
      return `${heure}h${minute}`;
    },
    async getAll() {
      try {
        const response = await ExamScheduleService.getAll({params: this.params});
        this.exams = response.data.data;
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
    async getCalender() {
      try {
        console.log("class:", this.params.class);
        const response = await ExamScheduleService.getCalender({params: {class: this.params.class}});

        this.calender = response.data;
        const unwrappedEvents = Array.from(this.calender);
        this.convertToEvents(unwrappedEvents);
      } catch (error) {
        console.error(error);
      }
    },
    async FilterRegister() {
      RegisterClass.getFilter({
        params: {},
      }).then(
        (response) => {
          this.levels = response.data.types;
          this.getAll();
          this.getCalender();
        },
        (error) => {
          console.error(error);
        }
      );
    },
    convertToEvents(data) {
      this.options.events = data.map((item) => ({
        title: item.exam_count,
        start: item.date,
      }));
      this.$nextTick(() => {
        const dayElements = document.querySelectorAll(".fc-daygrid-day");

        // Loop through each .fc-daygrid-day element
        dayElements.forEach((dayElement) => {
          // Check if .fc-daygrid-block-event exists within the current .fc-daygrid-day
          const eventElement = dayElement.querySelector(".fc-daygrid-block-event");

          // If it exists, find and style the .fc-daygrid-day-number within the current .fc-daygrid-day
          if (eventElement) {
            const dayNumberElement = dayElement.querySelector(".fc-daygrid-day-number");
            dayNumberElement.style.background = "#F1FAFA";
            dayNumberElement.style.cursor = "pointer";
          }
        });
      });
    },

    ChangeLevel(e) {
      if (e != null) {
        this.courses = [];
      } else {
        this.params.class = null;
        this.isSelected = false;
        this.selectedLevel = null;
      }
      this.selectedClass = null;
      this.isSelected = true;
      if (e) {
        this.classes = _.orderBy(e?.classe, "name");
        this.courses = _.orderBy(e.classe?.courses, "name");
      } else {
        this.getCalender();
        this.getAll();
        // this.eventDidMount();
      }
    },
    ChangeClass(e) {
      if (e != null) {
        this.params.class = [];
        this.params.class = e.id;

        this.courses = _.orderBy(e.courses, "name");
      } else {
        this.params.class = [];

        //  this.eventDidMount();
      }
      this.getCalender();
      this.getAll();
    },
    handleDateClick(arg) {
      console.log("arg:", arg.dateStr);
      const tdElement = arg.dayEl;
      const eventElement = arg.el;
      const activeTDElements = document.querySelectorAll(".active-td");
      const active = document.querySelectorAll(".fc-day-today");
      active.forEach((element) => {
        element.classList.remove("fc-day-today");
      });
      activeTDElements.forEach((element) => {
        element.classList.remove("active-td");
      });
      if (tdElement) {
        tdElement.classList.add("active-td");
      }
      if (eventElement) {
        eventElement.classList.add("active-td");
      }

      if (this.params.date != null) {
        this.params.date = arg.dateStr;
      }
      this.getAll();
    },
  },
};
</script>

<style lang="scss" scoped>
/* Ajoutez des styles ici si nécessaire */
</style>
